module.exports = __webpack_public_path__ + "static/img/3.50b778b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ajbz/3.png
// module id = dOAv
// module chunks = 0